/**
 * Utility to build a canonical URL from the current window location.
 * Drops query string and hash for cleanliness.
 */
export function buildCanonicalFromWindow(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const url = new URL(window.location.href);
    url.search = "";
    url.hash = "";
    return url.toString();
  } catch {
    return null;
  }
}

export function buildAlternateLanguagesForWindow(
  availableLanguages: string[] | undefined | null,
  defaultLanguage: string | undefined | null
): Array<{ hreflang: string; href: string }> {
  if (typeof window === "undefined") return [];
  const langs = availableLanguages && availableLanguages.length > 0 ? availableLanguages : [];
  const result: Array<{ hreflang: string; href: string }> = [];
  try {
    const url = new URL(window.location.href);
    const base = `${url.origin}${url.pathname}`;

    // x-default points to the base without language param
    result.push({ hreflang: "x-default", href: base });

    langs.forEach((lng) => {
      const u = new URL(base);
      // For default language, link to clean URL without param
      if (defaultLanguage && lng === defaultLanguage) {
        result.push({ hreflang: lng, href: base });
      } else {
        u.searchParams.set("language", lng);
        result.push({ hreflang: lng, href: u.toString() });
      }
    });
  } catch {
    // ignore
  }
  return result;
}
